module.exports = __webpack_public_path__ + "ab1.no2.a7c05eb9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/ab1.no2.jpg
// module id = KufU
// module chunks = 0